<div class="glass">
  <div class="glass-content">
    <h4 class="glass-content-title">{{ 'WebApp.v1.Shared.Anonymous.Title' | translate }}</h4>
    <div class="glass-content-description" [innerHTML]="'WebApp.v1.Shared.Anonymous.Description' | translate : { companyName: companyName } | markdown"></div>
  </div>
  <div class="glass-footer">
    <app-button
      class="button"
      [label]="'WebApp.v1.Shared.Buttons.Back' | translate"
      [fontSize]="14"
      [showOutlineOnHover]="false"
      backgroundColor="transparent"
      (click)="closeDialog()"
    ></app-button>
  </div>
</div>
